import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../Store/hooks";
import { motion, useAnimationControls } from "framer-motion";
import { toggleProfileModal } from "../Slices/profileModalSlice";
import BackgroundWatchlist from "./BackgroundWatchlist";
import classes from "./WatchlistModal.module.css";
import moment from "moment-timezone";
import { useGetUserProfileDetailsMutation } from "../Slices/httpSlice";
import { toast } from "react-toastify";
import { toggleWatchlistModal } from "../Slices/watchlistModalSlice";
import { toggleUserRatingsModal } from "../Slices/userRatingsModalSlice";
import { useNavigate } from "react-router-dom";

const ProfileModal = () => {
  const { profileModal } = useAppSelector((state) => state.profileModalSlice);

  const { user } = useAppSelector((state) => state.userSlice);

  const [userDetails, setUserDetails] = useState<any>(null);

  const controls = useAnimationControls();
  const dispatch = useAppDispatch();

  const variants = {
    hidden: {
      y: window.innerHeight,
      display: "none",
    },
    visible: {
      y: 0,
      display: "block",
    },
  };

  const [userProfileApi, { isLoading }] = useGetUserProfileDetailsMutation();

  useEffect(() => {
    if (profileModal) {
      controls.start("visible");
      hitApi();
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [profileModal]);

  const hitApi = async () => {
    const response: any = await userProfileApi({
      body: {
        user_id: user?.id,
      },
      token: user?.token,
    });
    console.log(response, "response....");

    if (response?.error) {
      if (response?.error?.status === 403) {
        toast.error("Please Login Again, Token Expired!");
      } else {
        toast.error(
          "Something Went Wrong!" ||
            response?.error?.data?.error?.error ||
            response?.error?.data?.error ||
            response?.error?.data?.message ||
            response?.error?.message
        );
      }
    } else {
      setUserDetails(response?.data?.result[0]);
    }
  };

  const closeProfileModal = () => {
    controls.start("hidden");
    dispatch(toggleProfileModal());
  };

  const navigate=useNavigate();

  return (
    <motion.div
      className={classes.modal}
      variants={variants}
      initial="hidden"
      animate={controls}
      transition={{
        duration: 0.5,
        type: "spring",
        damping: 10,
        stiffness: 100,
      }}
    >
      <BackgroundWatchlist>
        <div className={classes.navbar}>
          <button
            className={classes.close_btn}
            type="button"
            onClick={closeProfileModal}
          >
            <i className={`pi pi-times ${classes.close_icon}`} />
          </button>
        </div>
        <div className={classes.info_container}>
          <p className={classes.info}>
            <span className={classes.highlight}>{user?.username}'s</span>{" "}
            Profile
          </p>
          <p className={classes.info_brief}>
            Member since{" "}
            {new Date(userDetails?.date_time).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "long",
              year: "numeric",
            })}
          </p>
        </div>
      </BackgroundWatchlist>

      <div className={classes.watchlist_content} style={{ gap: "20px" }}>
        {/* <div className={classes.watchlist_header}>
          <p className={classes.watchlist_name}>Your Profile</p>
        </div> */}

        <div className={classes.profile_container}>
          <div className={classes.profile_content}>
            <p className={classes.label}>Username</p>
            <p className={classes.label_ans}>{userDetails?.username}</p>
          </div>

          <div className={classes.profile_content}>
            <p className={classes.label}>Email</p>
            <p className={classes.label_ans}>{userDetails?.email}</p>
          </div>

          <button
            className={classes.watchlist_header}
            style={{ marginTop: "10px" }}
            onClick={() => {
              closeProfileModal();
              dispatch(toggleWatchlistModal());
            }}
          >
            <p className={classes.watchlist_name} style={{ fontSize: "18px" }}>
              Your Watchlist
              <i className={`pi pi-chevron-right ${classes.chevron_right}`} />
            </p>
          </button>

          <button
            className={classes.watchlist_header}
            onClick={() => {
              closeProfileModal();
              dispatch(toggleUserRatingsModal());
            }}
          >
            <p className={classes.watchlist_name} style={{ fontSize: "18px" }}>
              Your Ratings
              <i className={`pi pi-chevron-right ${classes.chevron_right}`} />
            </p>
          </button>
          <button
            className={classes.watchlist_header}
            onClick={() => {
              closeProfileModal();
              navigate("/user-posts");
            }}
          >
            <p className={classes.watchlist_name} style={{ fontSize: "18px" }}>
              Your Posts
              <i className={`pi pi-chevron-right ${classes.chevron_right}`} />
            </p>
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default ProfileModal;
